import { IconButton, ThemingProps, useDisclosure } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { lazy } from '@loadable/component';
import { CoverImageInput } from 'apps/TenantApp/screens/Event/components/EventHeader/__generated__/EventHeader_updateEventImageUrl_Mutation.graphql';
import { ImageIcon } from 'components/icons';
import { SuspendWithSpinner } from 'components/SuspendWithSpinner';
import React, { FC } from 'react';
import { CropVariant } from './CroppableImage';

const ImageUploadModal = lazy(() => import('./ImageUploadModal'));

interface UpdateImageButtonProps {
  modalHeadingText: string;
  cropVariant?: CropVariant;
  imageURL: string;

  onImageSelected({
    newImage,
    newLocalImageURL,
    onComplete,
  }: {
    newImage: CoverImageInput | null;
    newLocalImageURL: string;
    onComplete: () => void;
  }): void;

  showDefaultImagesGallery?: boolean;
  defaultImage?: string;
  size?: ThemingProps['size'];
}

export const UpdateImageButton: FC<UpdateImageButtonProps> = ({
  modalHeadingText,
  cropVariant,
  imageURL,
  onImageSelected,
  showDefaultImagesGallery = false,
  defaultImage,
  size,
}: UpdateImageButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <IconButton
        ml={1}
        my={2}
        colorScheme="blue"
        borderRadius="full"
        icon={<ImageIcon />}
        onClick={onOpen}
        aria-label={t`Edit image`}
        size={size}
      />
      <SuspendWithSpinner>
        <ImageUploadModal
          headingText={modalHeadingText}
          cropVariant={cropVariant}
          isOpen={isOpen}
          onClose={onClose}
          onImageSelected={onImageSelected}
          imageURL={imageURL}
          showDefaultImagesGallery={showDefaultImagesGallery}
          defaultImage={defaultImage}
        />
      </SuspendWithSpinner>
    </>
  );
};
